
export default {
  data(){
    return{
      categoryOpen: false,
    }
  }
};
